import { render, staticRenderFns } from "./VProjectMomDetail.vue?vue&type=template&id=d84e1926&scoped=true&"
import script from "./VProjectMomDetail.vue?vue&type=script&lang=js&"
export * from "./VProjectMomDetail.vue?vue&type=script&lang=js&"
import style0 from "./VProjectMomDetail.vue?vue&type=style&index=0&id=d84e1926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84e1926",
  null
  
)

export default component.exports